'use strict';

var angular = require('angular');
var UserManagementManageUsersDirective = function UserManagementManageUsersDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/user-management-manage-users.html'),
    controller: 'UserManagementManageUsersController',
    link: function link($scope) {
      $scope.$on('user-management-manage-users-grid:edit', function (event, data) {
        $scope.showUserProfile(data);
      });
      $scope.$on('user-management-manage-users-grid: showDeleteModal', function () {
        angular.element('#delete-modal').modal('show');
      });
    }
  };
};
UserManagementManageUsersDirective.$inject = [];
module.exports = UserManagementManageUsersDirective;